import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/ui-custom/PageHero";
import GlassCard from "../components/ui-custom/GlassCard";
import Reveal from "../components/ui-custom/Reveal";
import { powerProductsCategories } from "../data/mock";
import { getIcon } from "../data/iconMap";

const PowerProducts = () => {
  return (
    <div>
      <PageHero
        eyebrow="Power Products"
        title="Power Products"
        subtitle="Reactors, transformers, PLCC components, instrument transformers and composite technologies engineered for high voltage transmission networks."
      />
      <section className="px-6 pb-28">
        <div className="max-w-6xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {powerProductsCategories.map((cat, i) => {
            const Icon = getIcon(cat.icon);
            return (
              <Reveal key={cat.slug} delay={i * 0.06}>
                <GlassCard tilt className="p-7 h-full flex flex-col">
                  <span className="w-14 h-14 rounded-xl flex items-center justify-center bg-qcyan/10 border border-qcyan/25 mb-5">
                    <Icon size={26} className="text-qcyan" />
                  </span>
                  <h3 className="font-display font-bold uppercase tracking-wide text-lg text-foreground mb-2">{cat.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed mb-6 flex-1">{cat.summary}</p>
                  <Link
                    to={`/power-products/${cat.slug}`}
                    className="inline-flex items-center gap-2 text-qcyan font-semibold text-sm tracking-wide hover:gap-3 transition-all"
                  >
                    View Details <ArrowRight size={16} />
                  </Link>
                </GlassCard>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default PowerProducts;
